package analytics

object NoOpAnalytics : Analytics {
    override fun screen(name: String, properties: Map<String, Any?>) = Unit
    override fun track(event: AnalyticsEvent) = Unit
    override fun identify(userId: String, properties: Map<String, Any?>) = Unit
    override fun setPersonProperties(properties: Map<String, Any?>) = Unit
    override fun register(key: String, value: Any?) = Unit
    override fun unregister(key: String) = Unit
    override fun optOut(optedOut: Boolean) = Unit
    override fun reset() = Unit
    override fun flush() = Unit
}
